import type { TweetsRow } from '../../db/types';
import { parseJsonField } from '../../lib/json-utils';

import { sanitizeTweetEntities } from './sanitizers';
import type { ReferencedTweet, Tweet, TweetAttachments } from './tweet';

export type { ArchiveTweet, DatabaseTweetResult, DatabaseTweetWithContext } from './db-types';

export function dbTweetToTweet(dbTweet: TweetsRow): Tweet {
  const result: Tweet = {
    id: dbTweet.id,
    text: dbTweet.text,
    authorId: dbTweet.authorId,
    createdAt: dbTweet.createdAt,
    likeCount: dbTweet.likeCount,
    retweetCount: dbTweet.retweetCount,
    replyCount: dbTweet.replyCount,
    quoteCount: dbTweet.quoteCount,
    bookmarkCount: dbTweet.bookmarkCount,
    impressionCount: dbTweet.impressionCount,
  };

  if (dbTweet.conversationId) {
    result.conversationId = dbTweet.conversationId;
  }
  if (dbTweet.lang) {
    result.lang = dbTweet.lang;
  }
  if (dbTweet.entities) {
    const raw = parseJsonField(dbTweet.entities, {} as unknown);
    const sanitized = sanitizeTweetEntities(raw);
    if (sanitized) {
      result.entities = sanitized;
    }
  }
  if (dbTweet.attachments) {
    const attachments = parseJsonField(dbTweet.attachments, {} as TweetAttachments);
    if (attachments) {
      result.attachments = attachments;
    }
  }
  if (dbTweet.referencedTweets) {
    const referencedTweets = parseJsonField(dbTweet.referencedTweets, [] as ReferencedTweet[]);
    if (referencedTweets) {
      result.referencedTweets = referencedTweets;
    }
  }

  return result;
}
